import React, { FC, ReactNode }               from 'react';
import { Icon, List, SemanticICONS }          from 'semantic-ui-react';
import { Cell, Grid, ICellProps, IGridProps } from 'styled-css-grid';

import { Tooltip } from '../../../components/util/messaging/ToolTip';

interface Props {
	gridProps?: IGridProps,
	icon?: SemanticICONS,
	itemLabel?: string,
	tooltip?: string,
	showTooltips?: boolean,
	iconCellProps?: ICellProps,
	labelCellProps?: ICellProps,
	mainContentCellProps?: ICellProps,
	mainContent?: ReactNode,
	additionalContent?: ReactNode[],
}

const defaultProps: Props = {
	gridProps:            {
		columns: `auto 1fr auto`
	},
	icon:                 'checkmark',
	itemLabel:            'Detail',
	tooltip:              'Info about this detail...',
	showTooltips:         false,
	iconCellProps:        {},
	labelCellProps:       {},
	mainContentCellProps: {
		className: 'text-right'
	},
	mainContent:          null,
	additionalContent:    [],
}

const StaticProjectActivityDetailItemContainer: FC<Props> = ( props ) => {
	
	return (
		
		<List.Item className={ 'peek-container' }>
			
			<List.Content>
				
				<Grid { ...props.gridProps }>
					
					<Cell { ...props.iconCellProps }>
						
						<Icon name={ props.icon } color={ 'purple' }/>
					
					</Cell>
					
					<Cell { ...props.labelCellProps }>
						
						<List.Header>{ props.itemLabel }: { props.showTooltips && <span className={ 'peek-item' }><Tooltip content={ props.tooltip }/></span> }</List.Header>
					
					</Cell>
					<Cell { ...props.mainContentCellProps }>
						
						<List.Description>
							
							{ props.mainContent ?? props.children }
						
						</List.Description>
					
					</Cell>
					
					{ props.additionalContent.map( content => (
						<Cell width={ 2 } left={ 2 }>
							{ content }
						</Cell>
					) ) }
				
				</Grid>
			</List.Content>
		</List.Item>
	);
};

StaticProjectActivityDetailItemContainer.defaultProps = defaultProps;

export { StaticProjectActivityDetailItemContainer }
